import { Fragment, h } from "preact";
import { RouterProps, useRouter } from "preact-router";
import { useBodyStyle } from "../hooks";
import { Container } from "../material";
import { formatCurrency } from "../services/utils";
import { Button } from "../material/button";
import { useData, type Product } from "../services/data";
import { getCategoryUrl } from "../services/navigation";
import { useShoppingBasket } from "../services/shoppingbasket";
import "./productpage.scss";
import { Categories } from "./categories";

export function ProductPage(props: RouterProps) {
    useBodyStyle("material");
    const data = useData();

    const [ctx] = useRouter();
    const productId = ctx.matches?.id;

    const product = data.products.find(n => n.id == productId);

    const addonCategoriesSet = !product?.addonCategories ? null : new Set(product.addonCategories);
    const addons = !addonCategoriesSet ? [] : data.products.filter(n => n.isAddon && n.addonCategories?.some(nn => addonCategoriesSet.has(nn)));
    const category = data.categories.find(n => n.id == product?.categoryId);

    //console.log(product, addonCategoriesSet);

    return (
        <Container class="column grow">
            <Categories categories={data.categories} categoryId={product?.categoryId!} />
            <Container class="grow row productpage">
                {
                    product && <Fragment>
                        <div class="gallery">
                            {
                                product.images[0] &&
                                <div class="heroimage">
                                    <img src={product.images[0]} />
                                </div>
                            }
                        </div>
                        <div class="product">
                            {
                                category
                                    ? <a href={getCategoryUrl(category)}>&lt;&lt; Tilbage til {category.title}</a>
                                    : <a href="/">&lt;&lt; Tilbage til forsiden</a>
                            }
                            <ProductView product={product} />
                            <br />
                            <div class="addonproducts">
                                {
                                    addons.map(addon => <AddonProductView product={addon} />)
                                }
                            </div>
                        </div>
                    </Fragment>
                }
            </Container>
        </Container>

    );
}

export function ProductView(props: { product: Product }) {
    const { setOrIncrementProductCount } = useShoppingBasket();
    return (
        <Fragment>
            <h1>{props.product.title}</h1>
            {
                props.product.description?.split("\n\n")
                    .map(paragraph => <p>{
                        paragraph.split("\n").map(line => <div>{line}</div>)
                    }</p>)
            }
            {
                !!props.product.itemPrice &&
                <div>
                    Pris: {formatCurrency(props.product.itemPrice)}
                </div>
            }
            {
                !props.product.itemPrice && !!props.product.dayPrice &&
                <div>
                    Dag: {formatCurrency(props.product.dayPrice)}
                </div>
            }
            {
                !props.product.itemPrice && !!props.product.weekendPrice &&
                <div>
                    Weekend: {formatCurrency(props.product.weekendPrice)}
                </div>
            }
            {
                !props.product.itemPrice && !!props.product.monthPrice &&
                <div>
                    Måned: {formatCurrency(props.product.monthPrice)}
                </div>
            }
            <br />
            <Button class="wide" onClick={() => setOrIncrementProductCount(props.product, undefined, 1)}>Tilføj</Button>
        </Fragment>
    )
}

export function AddonProductView(props: { product: Product }) {
    const { setOrIncrementProductCount } = useShoppingBasket();
    return (
        <div class="addonproduct">
            <div>
                {
                    props.product.images[0] &&
                    <img src={props.product.images[0]} />
                }
            </div>
            <div>
                <h2>{props.product.title}</h2>
                {
                    !!props.product.itemPrice &&
                    <div>
                        Pris: {formatCurrency(props.product.itemPrice)}
                    </div>
                }
                <Button size="small" onClick={() => setOrIncrementProductCount(props.product, undefined, 1)}>Tilføj</Button>
            </div>
        </div>
    )
}
